import { render, staticRenderFns } from "./batchlist.vue?vue&type=template&id=fe605282&scoped=true&"
import script from "./batchlist.vue?vue&type=script&lang=js&"
export * from "./batchlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe605282",
  null
  
)

export default component.exports